import type { ColDef } from 'ag-grid-community';

type GscDetailRow = {
  query: string;
  clicks: number;
  impressions: number;
  ctr: number;
  position: number;
};

type GscDetailColumn = ColDef<GscDetailRow> & {
  searchable?: boolean;
  title?: string;
  type?: string;
};

export const gscDetailColumnConfig: GscDetailColumn[] = [
  // {
  //   field: 'host_name',
  //   type: 'string',
  //   title: 'نشانی',
  //   searchable: true,
  //   cellRenderer: params => <URLRenderer url={params.value} />
  // },
  {
    field: 'query',
    type: 'string',
    title: 'کلمه',
    width: 360,
    minWidth: 150,
    flex: 1,
    searchable: true
  },
  // {
  //   field: 'country',
  //   type: 'string',
  //   title: 'کشور',
  //   width: 80,
  //   searchable: true
  // },
  {
    field: 'clicks',
    type: 'number',
    title: 'کلیک',
    width: 80,
    searchable: true
  },
  {
    field: 'impressions',
    type: 'number',
    title: 'ایمپرشن',
    width: 100,
    searchable: true
  },
  {
    field: 'ctr',
    type: 'number',
    title: 'CTR',
    width: 80,
    searchable: true
  },
  {
    field: 'position',
    type: 'number',
    title: 'پوزیشن',
    width: 90,
    searchable: true
  }
];
